document.addEventListener('click', async function (e) {

  const button = e.target.closest('.js_add_to_cart');
  if (!button) return;

  e.preventDefault();

  const productBlock = button.closest('.bundle-products__block');
  if (!productBlock) return;

  const variantSelect = productBlock.querySelector('.js_variant_change');

  if (!variantSelect) {
    console.error('Variant dropdown not found');
    return;
  }

  const selectedOption =
    variantSelect.options[variantSelect.selectedIndex];

  const variantId =
    selectedOption.getAttribute('data-value-handle');

  if (!variantId) {
    console.error('Variant ID not found');
    return;
  }

  // loading state
  button.disabled = true;
  button.classList.add('is-loading');

  try {

    // -----------------------------
    // Build form for theme cart
    // -----------------------------
    const form = document.createElement('form');

    const idInput = document.createElement('input');
    idInput.name = 'id';
    idInput.value = variantId;

    const qtyInput = document.createElement('input');
    qtyInput.name = 'quantity';
    qtyInput.value = 1;

    form.appendChild(idInput);
    form.appendChild(qtyInput);

    // -----------------------------
    // Add to cart using theme logic
    // -----------------------------
    const result = await addItem(form);

    const item = result.item;
    // -----------------------------
    // FORCE: ONLY CONFIRMATION POPUP
    // -----------------------------
    const purchaseConfirmation =
      document.querySelector('[data-purchase-confirmation-popup]');

    if (purchaseConfirmation) {

      r$1("confirmation-popup:open", null, {
        product: item
      });

    }

    // -----------------------------
    // Global event (safe for apps)
    // -----------------------------
    dispatchCustomEvent("cart:item-added", {
      product: item
    });

    button.classList.add('is-added');

  } catch (error) {

    console.error('Cart error:', error);

  } finally {

    button.disabled = false;
    button.classList.remove('is-loading');
  }

});
document.addEventListener('change', function (e) {
    if (e.target.classList.contains('js_variant_change')) {

        const parent = e.target.closest('.bundle-products__col');
        const selectedOption = e.target.options[e.target.selectedIndex];
        const price = selectedOption.getAttribute('data-price');
        const comparePrice = selectedOption.getAttribute('data-compare-at-price');
        const available = selectedOption.getAttribute('data-available');
        parent.querySelector('.js-price').textContent = price;

        const comparePriceEl = parent.querySelector('.js-compare-price');

        if (comparePrice) {
            comparePriceEl.textContent = comparePrice;
            comparePriceEl.style.display = 'block';
        } else {
            comparePriceEl.style.display = 'none';
        }
        const addToCartBtn = parent.querySelector('.js-add-to-cart');

        if (available === 'false') {
            addToCartBtn.textContent = 'Sold Out';
            addToCartBtn.style.pointerEvents = 'none';
            addToCartBtn.style.opacity = '0.5';
        } else {
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.style.pointerEvents = 'auto';
            addToCartBtn.style.opacity = '1';
        }
    }
});